"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "giarre": {
    "ba9630d2": [{
      "hkey": "25e2d155",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "altarello": [{
      "hkey": "25e2d155",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "74c670f5": [{
      "hkey": "d7c49aed",
      "slug": "carruba-san-leonardello",
      "name": "Carruba-San Leonardello",
      "primary": true,
      "skipSearch": false
    }],
    "carruba": [{
      "hkey": "d7c49aed",
      "slug": "carruba-san-leonardello",
      "name": "Carruba-San Leonardello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b1de1cee": [{
      "hkey": "d7c49aed",
      "slug": "carruba-san-leonardello",
      "name": "Carruba-San Leonardello",
      "primary": true,
      "skipSearch": false
    }],
    "san-leonardello": [{
      "hkey": "d7c49aed",
      "slug": "carruba-san-leonardello",
      "name": "Carruba-San Leonardello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "giarre"
    }]
  }
};
exports["default"] = _default;